import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import api from './api'

export default new Vuex.Store({
  state: {
    /**
     * Information about the active suite
     * @type {Object}
     */
    suite: {},

    /**
     * Whether the suite is unoccupied
     * @type {Boolean}
     */
    suiteIsUnoccupied: false,

    /**
     * Collection of animals associated with this suite
     * @type {Array}
     */
    animals: [],

    /**
     * Information about the active animal
     * @type {Object}
     */
    animal: {},

    /**
     * Information about recently adopted animals
     * @type {Array}
     */
    recentlyAdopted: [],

    /**
     * Global settings
     * @type {Object}
     */
    settings: {
      attractMessagesDuration: 5000,
      attractMessagesEndDelay: 500,
      attractMessagesLoopDelay: 5000,
      attractMessagesMaxDisplayed: 3,

      suiteColors: {
        202: 'blue',
        203: 'blue',
        204: 'blue',
        205: 'blue',
        206: 'blue',
        207: 'orange',
        208: 'orange',
        209: 'orange',
        210: 'orange',
        211: 'orange',
        216: 'green',
        217: 'green',
        218: 'green',
        219: 'green',
        220: 'green',
        221: 'green',
        222: 'blue',

        // Empty test suites
        997: 'orange',
        998: 'blue',
        999: 'green'
      }
    },

    /**
     * Track events to proceed to the next page in the Learn section
     * @type {Object}
     */
    nextLearnPage: false,

    /**
     * Initialized state: has initial data been loaded?
     * @type {Boolean}
     */
    initialized: false,

    /**
     * Show the circle border
     * @type {Boolean}
     */
    showCircleBorder: false,

    /**
     * Save time of last data refresh
     * @type {Number}
     */
    dataRefreshTimestamp: 0,

    /**
     * Save time of the last touch event
     * @type {Number}
     */
    lastTouchTimestamp: 0,

    /**
     * Last idle timeout date
     * @type {Number}
     */
    idleTime: 0
  },

  actions: {
    load: async ({ commit, state }, opts) => {
      const data = await api.load(opts.suiteId)

      // Reset unoccupied suite flag
      commit('SET_SUITE_IS_UNOCCUPIED', false)

      commit('SET_SUITE', data.suite)
      commit('SET_ANIMALS', data.animals)
      commit('SET_ANIMAL', data.animals[opts.animalIndex - 1])

      // Set initialized state to true
      commit('SET_INITIALIZED', true)
    },

    loadRecentlyAdopted: async ({ commit, state }) => {
      const adopted = await api.loadRecentlyAdopted(state.animal.species)
      commit('SET_RECENTLY_ADOPTED', adopted)
    },

    nextLearnPage ({ commit }) {
      commit('SET_NEXT_LEARN_PAGE', true)
      Vue.nextTick(() => {
        commit('SET_NEXT_LEARN_PAGE', false)
      })
    },

    setSuiteIsUnoccupied ({ commit }, value) {
      commit('SET_SUITE_IS_UNOCCUPIED', value)
    },

    showCircleBorder ({ commit }, value) {
      commit('SHOW_CIRCLE_BORDER', value)
    },

    setAnimal ({ commit }, data) {
      commit('SET_ANIMAL', data)
    },

    setDataRefreshTimestamp ({ commit }, timestamp) {
      commit('SET_DATA_REFRESH_TIMESTAMP', timestamp)
    },

    setLastTouchTimestamp ({ commit }, timestamp) {
      commit('SET_LAST_TOUCH_TIMESTAMP', timestamp)
    },

    setIdleTime ({ commit }, date) {
      commit('SET_IDLE_TIME', date)
    }
  },

  mutations: {
    SET_SUITE (state, data) {
      state.suite = data
    },

    SET_SUITE_IS_UNOCCUPIED (state, value) {
      state.suiteIsUnoccupied = value
    },

    SET_ANIMAL (state, data) {
      state.animal = data
    },

    SET_ANIMALS (state, data) {
      state.animals = data
    },

    SET_RECENTLY_ADOPTED (state, data) {
      state.recentlyAdopted = data
    },

    SET_INITIALIZED (state, value) {
      state.initialized = value
    },

    SET_NEXT_LEARN_PAGE (state, value) {
      state.nextLearnPage = value
    },

    SHOW_CIRCLE_BORDER (state, value) {
      state.showCircleBorder = value
    },

    SET_DATA_REFRESH_TIMESTAMP (state, value) {
      state.dataRefreshTimestamp = value
    },

    SET_LAST_TOUCH_TIMESTAMP (state, value) {
      state.lastTouchTimestamp = value
    },

    SET_IDLE_TIME (state, date) {
      state.idleTime = date
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js